import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import CardProfileActions from 'actions/CardProfileActions';
import {Record, List} from 'immutable';

@immutableStore
class CardProfileStore {
  constructor() {
    this.state = Record({
      cardProfiles: List(),
      wasError: false,
      isLoading: false,
    })();
    this.bindActions(CardProfileActions);
  }

  fetchAll() {
    this.setState({
      cardProfiles: List(),
      isLoading: true,
      wasError: false,
    });
  }

  fetchAllSuccess(cardProfiles) {
    this.setState({isLoading: false, cardProfiles});
  }

  fetchAllError() {
    this.setState({isLoading: false, wasError: true});
  }
}

export default alt.createStore(CardProfileStore);
